module.exports = __webpack_public_path__ + "img/icon_support_05.6c049306.png";